import { ChangeColor } from './ChangeColor';

export class ChangeTextOnDarkColor extends ChangeColor {
  type: string = 'ChangeTextOnDarkColor';
}
